export default {"src":"/_next/static/media/conflictsManagement.a9df62e5.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};